import React from "react";

import {
  Divider,
  Grid,
  Typography,
  Accordion,
  TextField,
  MenuItem,
  AccordionSummary,
  AccordionDetails,
  Button
} from "@material-ui/core";

import InfoTooltip from "../../general/InfoTooltip";
import CustomerPortalDialog from "../tools/CustomerPortalDialog";

import InfoIcon from '@material-ui/icons/Info';

export default function CreditFieldGroupPortalWizard(
  {
    renderCreditField,
    creditFunctions,
    createPortal,
    savePortal,
    portals,
    index,
    credit_id,
    metafields,
    setMetafields,
  }) {



  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5">Kundenportal für Kreditnehmer {index}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <CustomerPortalDialog
          personIndex={index}
          creditFunctions={creditFunctions}
          createPortal={createPortal}
          savePortal={savePortal}
          portals={portals}
          credit_id={credit_id}
          metafields={metafields}
          setMetafields={setMetafields}
          renderAs="wizard"
        />
      </Grid>
    </>
  );
}
